<template>
  <v-card>
    <v-app-bar elevation=0 class="flex-grow-0">
      <v-toolbar-title>
        Choississez les sessions à importer
      </v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn icon @click="closeModal">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-app-bar>

    <div class="p-3 import-sessions-list">
      <div v-for="sessionItem in items">
        <label>
          <input type="checkbox" v-model="selected" :value="sessionItem" />
          <div>{{`${ sessionItem.cycleName } - ${sessionItem.session.name}`}}</div>
        </label>
      </div>

      <v-pagination
        :length="totalPages"
        v-model="page"
        total-visible="6"
      />

      <div class="d-flex">
        <v-spacer></v-spacer>

        <v-btn :disabled="selected.length === 0" @click="handleImportSessions">
          Valider
        </v-btn>
      </div>
    </div>
  </v-card>
</template>

<script>
  import AuthService from '@/services/AuthService';

  import { getUserSessionsByCycle } from "@/api/cycleApi";
  import { random } from "@/helpers/utils";

  export default {
    name: "copy-sessions-modal",

    props: [
      "close",
      "cycleId",
      "onSave",
    ],

    data: function() {
      return {
        page: 1,
        itemsPerPage: 10,
        totalItems: 0,
        totalPages: 0,
        sessions: [],
        selected: [],
      }
    },

    async mounted() {
      await this.getSessions();
    },

    computed: {
      items: function() {
        const start = (this.page - 1) * this.itemsPerPage;
        const paginatedItems = this.sessions.slice(start).slice(0, this.itemsPerPage);

        return paginatedItems;
      }
    },

    methods: {
      closeModal() {
        this.close();
      },

      async getSessions() {
        const result = await getUserSessionsByCycle(AuthService.userId, this.cycleId);
        
        this.sessions = result.sessions;

        this.totalItems = result.totalItems;
        this.totalPages = Math.floor(result.totalItems / this.itemsPerPage) + 1;
      },

      handleImportSessions() {
        this.selected.forEach((item) => {
          const session = item.session;
          session.name = `${item.cycleName} - ${session.name} (${random(1000, 9999)})`;
          delete session.id;

          this.onSave(session)
        })
        
        this.close();
      }
    },
  }
</script>

<style>
  .import-sessions-list label {
    margin: 0 !important;
  }

  .import-sessions-list label div {
    margin: 5px;
    padding: 3px 30px;
    font-weight: bold;
    color: #666;
  }

  .import-sessions-list label input[type=checkbox] {
    display: none;
  }

  .import-sessions-list label :checked+div {
    background: #e5e5e58f;
    background-image: url(../../assets/img/check.png);
    background-size: 16px 16px;
    background-repeat: no-repeat;
    background-position: 3px 50%;
  }
</style>